module.exports = __webpack_public_path__ + "assets/media/plugin.a7c60cef.mp3";